import React from 'react';
import {RouteHandler} from 'react-router';

class ProTemplate extends React.Component {

    render() {
        return (
            <RouteHandler {...this.props} />
        )
    }
}


export default ProTemplate;



/** WEBPACK FOOTER **
 ** ./app/src/views/ProTemplate.js
 **/